import React from 'react';
import useLocationSearchParams from '@medflex/hooks/useLocationSearchParams';
import { useTranslation } from 'react-i18next';
import Button from '@medflex/components/stories/Button';
import Modal from '@medflex/components/stories/Modal';
import useModal from '../../hooks/useModal';
import useSessionChat from '../../hooks/useSessionChat';
import { MODALS } from '../../hooks/useIsModal';

const SessionChatDeleteMessageModule = () => {
  const { close } = useModal();
  const { messageId, chatId } = useLocationSearchParams();
  const { deleteMessage } = useSessionChat({ id: chatId });
  const { t } = useTranslation('global');

  const closeModal = () => close({ modal: MODALS.deleteSessionChatMessage, messageId, chatId });

  const handleDelete = async e => {
    e.preventDefault();
    if (messageId) {
      try {
        await deleteMessage({ id: messageId });
        closeModal();
      } catch {
        // noop
      }
    }
  };

  return (
    <Modal
      showCloseButton
      onClickCloseButton={() => {
        closeModal();
      }}
      title={t('delete_message_modal.delete')}
    >
      <p>{t('delete_message_modal.text')}</p>
      <p className="flex justify-end lg:justify-center w-full mt-16 lg:mt-8 mb-4">
        <Button className="w-128" type="button" onClick={handleDelete}>
          {t('delete_message_modal.delete')}
        </Button>
      </p>
    </Modal>
  );
};

export default SessionChatDeleteMessageModule;
